<template>
    <v-banner
        v-if="impersonatedUser"
        color="grey-lighten-2"
        class="impersonation-banner"
    >
        <template #default>
            <div class="d-flex justify-space-between align-center w-100">
                <div>
                    Estás suplantando a: <strong>{{ impersonatedUser.name }}</strong>
                </div>
                <v-btn
                    color="red"
                    class="ml-auto"
                    style="background-color: red; color: white"
                    @click="stopImpersonation"
                >
                    Salir de la impersonación
                </v-btn>
            </div>
        </template>
    </v-banner>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const impersonatedUser = ref(null)

const fetchStatus = async () => {
  try {
    const { data } = await axios.get('/api/impersonation/status', {
      withCredentials: true, // 👈 fora de headers
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
    })

    // Esperat del backend: { impersonating: bool, user: {...} }
    if (data?.impersonating && data?.user) {
      impersonatedUser.value = data.user
    } else {
      impersonatedUser.value = null
    }
  } catch (e) {
    // 👇 No trenquis el mounted si no hi ha sessió o no hi ha impersonació
    if (e?.response?.status === 401) {
      impersonatedUser.value = null
      return
    }
    console.error('impersonation/status error:', e?.response?.data || e.message)
  }
}

const stopImpersonation = async () => {
  try {
    const { data } = await axios.post('/api/impersonate/stop', {}, {
      withCredentials: true, // 👈 també aquí
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
    })

    if (data?.token) {
      localStorage.setItem('token', data.token)
      localStorage.removeItem('original_token')
      window.location.reload()
    } else {
      localStorage.removeItem('token')
      window.location.href = '/'
    }
  } catch (e) {
    console.error('impersonate/stop error:', e?.response?.data || e.message)
    // Fallback segur
    localStorage.removeItem('token')
    window.location.href = '/'
  }
}

onMounted(fetchStatus)
</script>


<style scoped>
.v-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    background-color: #DDDDDD;
    border-top: 1px solid #333333;
}

.impersonation-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    padding: 10px 20px;
    min-height: 48px;
    border-top: 1px solid #aaa;
    font-size: 14px;
}

</style>
